import { render, staticRenderFns } from "./ResourceGrid.vue?vue&type=template&id=4ca06000&"
import script from "./ResourceGrid.vue?vue&type=script&lang=js&"
export * from "./ResourceGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports